import { useEffect } from 'react';
import { auth } from '../auth';

import { AuthProvider, useAuthContext } from './auth-context';

type Children = {
  children: React.ReactNode;
  logoutUrl?:string;
  onAuthorized: () => void;
  onSignOut?: () => void;
};

export const SetAuthRef = ({ children, onAuthorized, onSignOut, logoutUrl }: Children) => {
  const { authenticated, logOut } = useAuthContext();

  useEffect(() => {
    auth.signOut = () => {
      if (onSignOut) {
        onSignOut();
      }
      logOut(logoutUrl);
    };
    
    auth.isAuthenticated = () => authenticated;
    if (authenticated) {
      onAuthorized();
    }
  }, [authenticated]);

  return authenticated && <>{children}</>;
};

export const LegacyAuthContext = (props: Children) => {
  return (
    <AuthProvider >
      <SetAuthRef {...props} />
    </AuthProvider>
  );
};
